import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  Router
} from '@angular/router';

import {
  filter,
  map,
  mergeMap,
  takeUntil
} from 'rxjs/operators';

import { SummitDisposing } from '@summit/models';

@Injectable({
  providedIn: 'root'
})
export class TitleService extends SummitDisposing {
  defaultTitle?: string;
  titleUpdates = new Map();

  constructor(private router: Router, private title: Title, private activatedRoute: ActivatedRoute) {
    super();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((_route) => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data),
        takeUntil(this.disposing$)
      )
      .subscribe((routeData) => {
        //console.log(`Title: ${routeData['title']}`, routeData);
        this.defaultTitle = routeData['title'];
        this.titleUpdates.clear();
        this.updateTitle();
      });
  }

  public updateTitle(template: string | null = null, value: string | null = null, prefix: string | null = null) {
    let newTitle = this.defaultTitle;
    if (template) {
      this.titleUpdates.set(template, value);
    }
    // console.log(`Updating Title: '${newTitle}' with '${template}' to '${value}'`, this.titleUpdates);
    if (newTitle !== undefined) {
      this.titleUpdates.forEach((value, key) => {
        const searchString = `\[${key}\]`;
        // console.log(`Searching for '${searchString}' in '${newTitle}' to be replace with '${this.titleUpdates[key]}'`);
        newTitle = newTitle?.replace(searchString, value);
      });
      // console.log(`Updating Title with ${template} to ${value} so new title ${newTitle}`);
      if (prefix) {
        this.title.setTitle(`${prefix} ${newTitle.trim()}`);
      } else this.title.setTitle(newTitle.trim());
    }
  }

  public getTitle(): string {
    return this.title.getTitle();
  }
}
